import { render, staticRenderFns } from "./addCommendDialog.vue?vue&type=template&id=764ef3d5&scoped=true"
import script from "./addCommendDialog.vue?vue&type=script&lang=js"
export * from "./addCommendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764ef3d5",
  null
  
)

export default component.exports